import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useParamValue } from "PFCore/hooks/use_param_value";
import { useCallback } from "react";

export type StartDateCondition = {
  from: string | undefined; // iso date
  to: string | undefined; // iso date
};

const parseRawStartDate = (rawValue: string): StartDateCondition | null => {
  const [from, to] = rawValue?.split("_") || [];

  if (!from && !to) {
    return null;
  }

  return {
    from,
    to
  };
};

export const useStartDateFilter = () => {
  const { formatISODate } = useDateFormatter();

  const formatStartDate = useCallback(
    ({ from, to }: StartDateCondition) => [formatISODate(from), formatISODate(to)].join("_"),
    [formatISODate]
  );

  const { value, setValue, ...useParamValueReturn } = useParamValue<StartDateCondition | null>("start_date", {
    parse: parseRawStartDate,
    format: formatStartDate
  });

  return {
    startDateCondition: value,
    setStartDateCondition: setValue,
    ...useParamValueReturn
  };
};
